import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import { Link } from '@mui/material';
import ContactPopup from '../components/Contactpopup';

function Copyright() {
  return (
    <React.Fragment>
      <div style={{fontSize: 22, marginBottom:25, color:'#990000', fontWeight: 'bolder', textAlign:'center'}}>
        {'© '}
        <Link color="inherit" href="https://mktech.cloud/">
          MKTech.cloud
        </Link>{' '}
        {new Date().getFullYear()}
      </div>
    </React.Fragment>
  );
}

function ProductSmokingHero() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMailTo = () => {
    window.location.href = 'mailto:solutions@mktech.cloud';
  };

  return (
    <>
      <Container
        component="section"
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 9, mb: 5 }}
      >
        <Button
          sx={{
            border: '4px solid currentColor',
            borderRadius: 0,
            height: 'auto',
            py: 2,
            px: 5,
            borderRadius:1,
          }}
          onClick={handleMailTo}
        >
          <Typography variant="h4" component="span">
            Got any questions? Need help?
          </Typography>
        </Button>
        <Typography variant="subtitle1" sx={{ my: 3 }}>
          We are here to help. Get in touch!
        </Typography>
      </Container>
      <Copyright />
      <ContactPopup open={open} handleClose={handleClose} />
    </>
  );
}

export default ProductSmokingHero;
